import { Component, ViewChild } from '@angular/core';
import { ToastContainerDirective } from 'ngx-toastr';

@Component({
  selector: 'wsb-shop-purchase-success',
  templateUrl: './shop-purchase-success.component.html',
  styleUrls: ['./shop-purchase-success.component.scss'],
  standalone: false
})
export class ShopPurchaseSuccessComponent {
  @ViewChild(ToastContainerDirective) toastContainerSuccess: ToastContainerDirective;

  constructor() {}
}
